<template>
  <div class="form-group">
    <label class="form-item has-label form-item-select"
      v-bind:class="{'has-error': errors.has(field.key), 'form-item-disabled': field.disabled}">
      <small class="label" v-html="sanitizedFieldTitle"></small>
      <select class="form-control"
        v-bind:name="field.key"
        v-on:change="$emit('input', $event.target.value);processSelection($event.target.value)"
        v-validate="validationRules"
        v-bind:data-vv-as="strippedFieldTitle"
        v-bind:disabled="field.disabled"
        tabindex="1">
        <option v-bind:selected='value === ""'></option>
        <option v-for="option in field.options"
          v-bind:selected="value === option.value"
          v-bind:value="option.value"
          v-bind:key="option.value">
          {{ option.title }}
        </option>
      </select>
    </label>
    <small class="form-help-text"
           v-html="sanitizedHelpText"
           v-on:click="openLearnMoreModal(field.key)">
    </small>
    <span class="invalid-feedback"
      v-if="errors.has(field.key)">
      {{ errors.first(field.key) }}
    </span>
  </div>
</template>

<script>
import $ from 'jquery';
import InputMixin from '@/mixins/InputMixin';
import SegmentMixin from '@/mixins/SegmentMixin';

/**
 * DropDown
 * -- Implements v-model
 *
 * A field that renders a select input with a list of options.
 */

export default {
  name: 'DropDown',
  mixins: [
    InputMixin,
    SegmentMixin,
  ],
  props: {
    disabled: Boolean,
  },
  methods: {
    /**
     * For panel upgrade answered yes we need to show that it
     * is not available modal and track event selection.
     * @param event {Event} the event raised by an input
     */
    processSelection(value) {
      if (this.field.key !== 'upgrade_electrical_panel') {
        return;
      }
      if (value === 'yes') {
        $('#noUpgradeAvailableModal').addClass('show');
        $('#noUpgradeAvailableModal').attr('style', 'display: block');
        this.trackEvent('Electrical-panel-required-selected');
      } else {
        $('#noUpgradeAvailableModal').removeClass('show');
        $('#noUpgradeAvailableModal').attr('style', 'display: none');
        this.trackEvent('Electrical-panel-not-required-selected');
      }
    },
    /**
     * Open learn more modal for matching help text
     * @param {*} value
     */
    openLearnMoreModal(value) {
      if (value !== 'upgrade_electrical_panel') {
        return;
      }
      $('#waterHeaterLearnMoreModal').addClass('show');
      $('#waterHeaterLearnMoreModal').attr('style', 'display: block');
      this.trackEvent('Do-I-need-electrical-panel-modal-opened');
    },
  },
};
</script>
